import * as yup from 'yup';

import './fixMessages';
import { validateWhitelabelInfo, validateWhitelabelBase } from './whitelabel';

export default yup
  .object()
  .concat(validateWhitelabelBase)
  .concat(validateWhitelabelInfo);
